export default __webpack_public_path__ + "static/media/generic_simple.4d74ecc0.mp3";